import { ApplicantApplicationState } from 'src/redux/slices/Application'

export const useAssignedAgentId = (
  applicationState: ApplicantApplicationState | undefined,
  fallbackAgentId: string | string[] | null
): string | undefined => {
  let agentId: string | undefined
  agentId = applicationState?.application?.agent_id
  if (agentId) {
    return agentId
  }
  agentId = applicationState?.application?.agent?.id
  if (agentId) {
    return agentId
  }

  if (fallbackAgentId && fallbackAgentId !== 'all') {
    if (typeof fallbackAgentId === 'string') {
      return fallbackAgentId
    }
    if (typeof fallbackAgentId === 'object') {
      return fallbackAgentId.join('')
    }
  }
}
